import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from 'react';
import { StaticQuery } from 'gatsby';
import { FaBars, FaWindowClose } from 'react-icons/fa';
import Wrapper from '@interness/web-core/src/components/structure/Wrapper/Wrapper';
import Link from '@interness/web-core/src/components/elements/Link/Link';
import LanguageToggler from '@interness/web-core/src/components/modules/LanguageToggler';
import { findT } from '@interness/web-core/src/components/_helpers';
import RolexClock from '@interness/web-core/src/components/modules/RolexClock/RolexClock';
import Logo from '@interness/web-core/src/components/media/Logo/Logo';
import { GlobalContext } from '@interness/web-core/src/providers';
import Navigation from './Navigation';
import * as S from './styles';

// TODO REFACTOR THIS MESS
import { jsx as ___EmotionJSX } from "@emotion/react";
let Header = /*#__PURE__*/function (_React$Component) {
  function Header(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.rolexRetailer = false;
    _this.handleMain = () => {
      const main = window.document.querySelector('main');
      if (_this.state.options.sticky && window.innerWidth > _this.state.options.smallScreenThreshold) {
        main.setAttribute('style', `padding-top: ${_this.state.options.fullHeight}`);
      } else {
        main.setAttribute('style', `padding-top: 0;`);
      }
    };
    _this.handleScroll = () => {
      if (_this.state.options.sticky) {
        const currPos = window.pageYOffset;
        if (currPos >= _this.state.options.changePos) {
          _this.setState({
            collapsed: true
          });
        } else {
          _this.setState({
            collapsed: false
          });
        }
      } else {
        _this.setState({
          collapsed: false
        });
      }
    };
    //ugh
    _this.handleWindowResize = () => {
      if (window.innerWidth < _this.state.options.smallScreenThreshold) {
        _this.setState({
          smallScreen: true,
          options: {
            sticky: false,
            collapses: false,
            changePos: _this.props.changePos,
            fullHeight: _this.props.config.fullHeight,
            collapsedHeight: _this.props.config.collapsedHeight,
            smallScreenThreshold: _this.props.config.smallScreenThreshold
          }
        });
        _this.handleMain();
      } else {
        _this.setState({
          smallScreen: false,
          collapsed: false,
          options: {
            sticky: _this.props.sticky,
            collapses: _this.props.collapses,
            changePos: _this.props.changePos,
            fullHeight: _this.props.config.fullHeight,
            collapsedHeight: _this.props.config.collapsedHeight,
            smallScreenThreshold: _this.props.config.smallScreenThreshold
          }
        });
        _this.handleMain();
      }
    };
    _this.state = {
      mounted: false,
      options: {
        sticky: _this.props.sticky,
        collapses: _this.props.collapses,
        changePos: _this.props.changePos,
        fullHeight: _this.props.config.fullHeight,
        collapsedHeight: _this.props.config.collapsedHeight,
        smallScreenThreshold: _this.props.config.smallScreenThreshold
      },
      collapsed: false,
      smallScreen: false
    };
    return _this;
  }
  _inheritsLoose(Header, _React$Component);
  var _proto = Header.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
      mounted: true
    }));
    this.handleWindowResize();
    this.handleScroll();
    window.addEventListener('resize', this.handleWindowResize);
    if (this.state.options.sticky && !this.state.smallScreen) {
      if (this.state.options.collapses) {
        window.addEventListener('scroll', this.handleScroll);
      }
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize);
    window.removeEventListener('scroll', this.handleScroll);
  };
  _proto.render = function render() {
    return ___EmotionJSX(StaticQuery, {
      query: query,
      render: data => {
        const menu = data.directusMenus ? findT(data.directusMenus.translations, this.props.lang).config : null;
        const newMenu = data.directusMenusNew ? data.directusMenusNew.config : null;
        const rolexData = data.directusProject.config[0].brand_config[0];
        const project = data.directusProject;
        const translations = findT(project.translations, this.props.lang);
        return ___EmotionJSX(GlobalContext.Consumer, null, context => {
          const {
            primaryMenuOpen,
            togglePrimaryMenu
          } = context;
          const toggleMenu = () => togglePrimaryMenu(!primaryMenuOpen);
          return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(S.Container, {
            sticky: this.state.options.sticky,
            collapsed: this.state.collapsed
          }, ___EmotionJSX(Wrapper, null, ___EmotionJSX(S.PrimaryHeader, {
            collapsed: this.state.collapsed
          }, ___EmotionJSX(S.Logo, {
            collapsed: this.state.collapsed,
            maxWidth: project.logo.localFile.childImageSharp.original.width
          }, ___EmotionJSX(Link, {
            to: "/"
          }, ___EmotionJSX(Logo, {
            logo: project.logo.localFile,
            title: translations.seo_title
          }))), primaryMenuOpen ? this.state.smallScreen && ___EmotionJSX(S.Toggler, {
            onClick: toggleMenu,
            "aria-label": 'Menu'
          }, ___EmotionJSX(FaWindowClose, null)) : this.state.smallScreen && ___EmotionJSX(S.Toggler, {
            onClick: toggleMenu,
            "aria-label": 'Menu'
          }, ___EmotionJSX(FaBars, null)), ___EmotionJSX(S.DesktopNavigation, {
            visible: this.state.mounted ? !this.state.smallScreen : false
          }, ___EmotionJSX(Navigation, {
            menu: menu,
            newMenu: newMenu
          })), ___EmotionJSX(S.CartSection, {
            id: "int-cart"
          }), ___EmotionJSX(LanguageToggler, {
            location: this.props.location
          }), rolexData && rolexData.rolex_clock && ___EmotionJSX(S.RolexWatch, null, ___EmotionJSX(RolexClock, null))))), ___EmotionJSX(S.MobileNavigation, {
            visible: this.state.smallScreen && primaryMenuOpen
          }, ___EmotionJSX(Navigation, {
            menu: menu,
            newMenu: newMenu,
            direction: "column",
            expanded: true
          })));
        });
      }
    });
  };
  return Header;
}(React.Component);
const query = "3564151331";
Header.defaultProps = {
  sticky: true,
  collapses: true,
  changePos: 100,
  accentBorder: false
};
export default Header;